import { isPlatformServer } from '@angular/common';
import {
    Directive,
    ElementRef,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    Renderer2,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { sleep } from '../../lib/sleep';
import { ScrollService } from '../../services/scroll.service';

@Directive({
  selector: '[inView]',
  standalone: true,
})
export class InViewDirective implements OnInit, OnDestroy {
  // listenFunc will hold the function returned by "renderer.listen"
  listenFunc: () => void;
  scrollSub: Subscription;
  @Input() inView: string | boolean;
  @Input() inViewKeep: boolean;

  constructor(
    private renderer: Renderer2,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private element: ElementRef,
    @Inject(PLATFORM_ID) private platformId: string,
    private scrollService: ScrollService
  ) {}

  async ngOnInit() {
    if (isPlatformServer(this.platformId)) return;
    this.displayElement();
    await sleep(0);
    this.displayElement();
    this.renderer.listen('window', 'resize', () => this.displayElement());
    this.scrollSub = this.scrollService.onScroll.subscribe(() => this.displayElement());
  }

  displayElement() {
    if (this.isVisible()) this.doDisplayElement();
    else if (!this.inViewKeep) this.viewContainer.clear();
  }

  isVisible() {
    if (this.inView) return true; // override
    const el = <HTMLElement>this.element.nativeElement.parentElement;
    const bounds = el.getBoundingClientRect();
    const top = bounds.top;
    const bottom = bounds.bottom;
    const buffer = 20;
    const headerHeight = 64; // for mobile dialogs we can't count the header height

    if (bottom < -buffer) return false;
    if (top > window.innerHeight - headerHeight + buffer) return false;
    return true;
  }

  private doDisplayElement() {
    if (!this.viewContainer.get(0)) this.viewContainer.createEmbeddedView(this.templateRef);
  }

  shouldShow() {
    return;
  }

  ngOnDestroy() {
    this.listenFunc?.();
    this.scrollSub?.unsubscribe();
  }
}
